// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.









export const environment = {
  production: false,
  sonarAlarma:false,
  seleccionPago : 'production',   // sandbox 'production'
  apiProduccion: 'AbJxWjnxki76MZv9Q4-9YxerXwGQW7KmjrRwkLkZ4TXiIsGVRZlDM9clXnqOs01WspL--36mQYfiMvun',
  apiSandbox: 'AQbcrhGt159tXWdlPx_iMx4CtMeSmqubpCce5deHZvTlqjesTnd5IYDDqVfiVMExdJmyYCuamMIEf2_k',
  
  SOCKET_ENDPOINT: 'http://localhost:3000',
  rutaweb: 'http://localhost:3000/upload/descarga',
  rutaverificaxls: 'http://localhost:3000/upload/verificaxls/',
  rutaverificaxlsporevento: 'http://localhost:3000/upload/verificaxls_eventos/',
  rutaverificaxls_agenciaxevento: 'http://localhost:3000/upload/verificaxls_agencia_eventos/',
  rutaverificaxlsagencia: 'http://localhost:3000/upload/verificaxlsagencia/',
};

